module.exports = __webpack_public_path__ + "img/app_img.5daf4bb8.png";